var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericField',{attrs:{"value":_vm.selectedEntityUuid,"field":_vm.field,"items":_vm.computedApiItems,"classes":_vm.classes,"clearable":!_vm.readOnly},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }